// Generated by purs version 0.13.8
"use strict";
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Scale = function (scale) {
    this.scale = scale;
};
var Additive = function (add, sub, zero) {
    this.add = add;
    this.sub = sub;
    this.zero = zero;
};
var zero = function (dict) {
    return dict.zero;
};
var sub = function (dict) {
    return dict.sub;
};
var scaleIntNumber = new Scale((function () {
    var $6 = Data_Semiring.mul(Data_Semiring.semiringNumber);
    return function ($7) {
        return $6(Data_Int.toNumber($7));
    };
})());
var scaleIntInt = new Scale(Data_Semiring.mul(Data_Semiring.semiringInt));
var scale = function (dict) {
    return dict.scale;
};
var negate = function (dictAdditive) {
    return function (n) {
        return sub(dictAdditive)(zero(dictAdditive))(n);
    };
};
var additiveNumber = new Additive(Data_Semiring.add(Data_Semiring.semiringNumber), Data_Ring.sub(Data_Ring.ringNumber), 0.0);
var additiveInt = new Additive(Data_Semiring.add(Data_Semiring.semiringInt), Data_Ring.sub(Data_Ring.ringInt), 0);
var add = function (dict) {
    return dict.add;
};
var sum = function (dictFoldable) {
    return function (dictAdditive) {
        return Data_Foldable.foldl(dictFoldable)(add(dictAdditive))(zero(dictAdditive));
    };
};
var abs = function (dictOrd) {
    return function (dictAdditive) {
        return function (x) {
            var $5 = Data_Ord.lessThan(dictOrd)(x)(zero(dictAdditive));
            if ($5) {
                return negate(dictAdditive)(x);
            };
            return x;
        };
    };
};
module.exports = {
    add: add,
    scale: scale,
    sub: sub,
    zero: zero,
    Additive: Additive,
    negate: negate,
    sum: sum,
    abs: abs,
    Scale: Scale,
    additiveInt: additiveInt,
    scaleIntInt: scaleIntInt,
    additiveNumber: additiveNumber,
    scaleIntNumber: scaleIntNumber
};
//# sourceMappingURL=index.js.map
